// A phone runs as a camera or as a remote for a desktop-run session (R6). Decided once per load, before WebRTC starts, since the type rides the offer.

import { DEVICE_TYPES, IS_CAMERA, IS_MOBILE, IS_OUTPUT } from './constants'

const STORAGE_KEY = 'oylo-client-mode'

/** What this page is, regardless of mode: carried in user-channel presence so a phone can see a desktop before it connects. */
export const deviceClass = () =>
	IS_CAMERA
		? DEVICE_TYPES.CAMERA
		: IS_OUTPUT
			? DEVICE_TYPES.SCREEN
			: IS_MOBILE
				? DEVICE_TYPES.MOBILE
				: DEVICE_TYPES.DESKTOP

/** The offer's `device_type`: a phone in remote mode is `remote`, everything else its class. */
export const offerDeviceType = mode =>
	deviceClass() === DEVICE_TYPES.MOBILE && mode === 'remote' ? DEVICE_TYPES.REMOTE : deviceClass()

/** Does this page choose a mode at all? Only the mobile app does. */
export const hasClientMode = () => deviceClass() === DEVICE_TYPES.MOBILE

/** Override, else the saved choice, else remote when another client in user presence is a desktop, else camera. */
export const resolveClientMode = ({ override, saved, presence, me }) =>
	override ??
	saved ??
	(presence?.some(p => p.device_type === DEVICE_TYPES.DESKTOP && p.clientId !== me) ? 'remote' : 'camera')

export const savedClientMode = () => {
	try {
		const v = localStorage.getItem(STORAGE_KEY)
		return v === 'remote' || v === 'camera' ? v : null
	} catch {
		return null
	}
}

export const saveClientMode = mode => {
	try {
		localStorage.setItem(STORAGE_KEY, mode)
	} catch {
		// Private mode: the choice lasts this load only.
	}
}
